import { createContext } from 'react'

import { UserTokenContextType } from './types'

export const UseUserTokenContext = createContext<UserTokenContextType | undefined>(undefined)
